import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { EmailEvent } from './email_events';

@Injectable({ providedIn: 'root' })
export class EmailEventProvider extends DomainEventProvider<EmailEvent> {}
